<h2 mat-dialog-title class="av-section-title">
  {{ 'backoffice.licences.adjust.title' | translate }}
</h2>

<mat-dialog-content class="d-flex flex-column gap-3">
  <p class="av-section-hint m-0">{{ 'backoffice.licences.adjust.hint' | translate }}</p>

  <form [formGroup]="formGroup" class="d-flex flex-column gap-3">
    <label class="d-flex flex-column gap-1" for="adjust-component">
      <span class="av-meta">{{ 'backoffice.licences.filters.component' | translate }}</span>
      <select id="adjust-component" class="av-field" formControlName="component_type">
        @for (component of availableComponents; track component.component_type) {
          <option [value]="component.component_type">
            {{
              'backoffice.licences.adjust.component_option'
                | translate
                  : {
                      component: component.componentLabelKey | translate,
                      product: component.stripeProductNameKey | translate,
                      purchased: component.purchased,
                      free: component.free,
                    }
            }}
          </option>
        }
      </select>
    </label>

    <label class="d-flex flex-column gap-1" for="adjust-delta">
      <span class="av-meta">{{ 'backoffice.licences.adjust.delta' | translate }}</span>
      <input
        id="adjust-delta"
        type="number"
        class="av-field"
        [attr.min]="-deltaMax"
        [attr.max]="deltaMax"
        formControlName="delta"
      />
    </label>

    @if (delta() > 0) {
      <div
        class="av-banner p-3 d-flex align-items-start gap-2"
        data-testid="adjust-increase-warning"
      >
        <mat-icon aria-hidden="true">payments</mat-icon>
        <span>{{ 'backoffice.licences.adjust.increase_warning' | translate }}</span>
      </div>
    } @else if (delta() < 0) {
      <div
        class="av-banner p-3 d-flex align-items-start gap-2"
        data-testid="adjust-decrease-warning"
      >
        <mat-icon aria-hidden="true">event_busy</mat-icon>
        <span>
          {{ 'backoffice.licences.adjust.decrease_warning' | translate }}
          {{ 'backoffice.licences.notes.pending_cancellation' | translate }}
        </span>
      </div>
    }

    <label class="d-flex flex-column gap-1" for="adjust-reason">
      <span class="av-meta">{{ 'backoffice.licences.reason' | translate }}</span>
      <textarea
        id="adjust-reason"
        class="av-field"
        rows="3"
        [attr.maxlength]="reasonMax"
        formControlName="reason"
      ></textarea>
    </label>
  </form>
</mat-dialog-content>

<mat-dialog-actions class="d-flex justify-content-end gap-2">
  <button type="button" class="av-btn" (click)="cancel()">
    {{ 'backoffice.common.actions.cancel' | translate }}
  </button>

  <button
    type="button"
    class="av-btn av-btn-primary"
    [disabled]="!formGroup.valid || delta() === 0"
    (click)="confirm()"
  >
    {{ 'backoffice.licences.adjust.submit' | translate }}
  </button>
</mat-dialog-actions>
